let dialogEventsRegistered = false;
export function areDialogEventsRegistered() { return dialogEventsRegistered; }
export function completeDialogEventsRegistration() { dialogEventsRegistered = true; }
